import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'

Vue.use(Router)
const routes = [
    {path: '/', redirect: '/home'},
    {
        path: '/home',  // 首页  tab
        name: 'home',
        component: () => import('@/pages/Home'),
        children: [
            {
                path: '',
                name: '视频双选会列表',
                component: () => import('@/pages/jobfair/List')
            }
        ]
    },
    {
        path: '/my_jobfair',
        name: '我的面试',
        component: () => import('@/pages/home/My')
    },
    {
        path: '/sub',  // 子页面  头部带返回箭头
        name: 'sub',
        component: () => import('@/pages/Sub'),
        children: [
            {
                path: 'company',
                name: '企业大厅',
                component: () => import('@/pages/company/List'),
            },
            {
                path: 'company-detail',
                name: '企业详情',
                component: () => import('@/pages/company/Detail'),
            },
            {
                path: 'jobfair-detail',
                name: '双选会详情',
                component: () => import('@/pages/jobfair/Detail')
            },
            {
                path: 'my_jobfair',
                name: '我的面试',
                component: () => import('@/pages/home/My')
            }
        ]
    },
    {
        path: '/attention',
        name: '关注',
        component: () => import('@/pages/Attention'),
    },
    {
        path: '/interview',
        name: '面试加载',
        component: () => import('@/pages/Interview'),
    },
    {
        path: '/404',
        name: 'not_found',
        component: () => import('@/pages/Unfound'),
    },
    {
        path: '*', // 页面不存在的情况下会跳到404页面
        redirect: '/404',
        name: 'not_found',
        hidden: true
    }
]
const router = new Router({
    mode: 'history',
    routes
})

// simple history management
const history = window.sessionStorage
// history.clear()
routes.forEach((items) => {
    if (history.getItem(items.path) !== undefined) {
        history.removeItem(items.path)
    }
})

let historyCount = 0 // history.getItem('count') * 1 || 0
history.setItem('/', 0)
let isPush = false
let isTouchStart = false
let endTime = Date.now()
let methods = ['push', 'go', 'replace', 'forward', 'back'];

document.addEventListener('touchend', () => {
    isTouchStart = false
    endTime = Date.now()
})
document.addEventListener('touchstart', () => {
    isTouchStart = true
})
methods.forEach(key => {
    let method = router[key].bind(router)
    router[key] = function (...args) {
        isPush = true
        method.apply(null, args)
    }
})

router.beforeEach(function (to, from, next) {
    store.commit('updateLoadingStatus', {isLoading: true})


    // eslint-disable-next-line
    if (_hmt) {
        if (to.path) {
            // eslint-disable-next-line
            _hmt.push(['_trackPageview', to.fullPath]);
        }
    }

    const toIndex = history.getItem(to.path)
    const fromIndex = history.getItem(from.path)
    let direction

    if (toIndex) {
        if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
            direction = 'forward'
        } else {
            direction = 'reverse'
        }
    } else {
        ++historyCount
        history.setItem('count', historyCount)
        to.path !== '/' && history.setItem(to.path, historyCount)
        direction = 'forward'
    }

    // 判断是否是ios左滑返回 或者 右滑前进
    if (toIndex && toIndex !== '0' && !isPush && (((Date.now() - endTime) < 377) || isTouchStart)) {
        store.commit('updateDirection', {direction: ''})
    } else {
        store.commit('updateDirection', {direction: direction})
    }
    isTouchStart = false

    if (/\/http/.test(to.path)) {
        let url = to.path.split('http')[1]
        window.location.href = `http${url}`
    } else {
        next()
    }
})
router.afterEach(function (to) {
    isPush = false
    store.commit('update_route', {data: to})
    store.commit('updateLoadingStatus', {isLoading: false})

    if (process.env.NODE_ENV === 'production') {
        // ga && ga('set', 'page', to.fullPath)
        // ga && ga('send', 'pageview')
    }
})

export default router